import $ from 'jquery';
import $modal from '../../../node_modules/bootstrap/js/dist/modal';

export default function utils() {
  
  $('html').removeClass('no-js');
  
  //_blank link esterni
	$('a.external').on('click', function() {
		window.open(this.href);
		return false;
	});
  
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js